<template>
  <div class="company-info container-fluid">
    <home-title title="COMPANY PROFILE" subTitle="公司简介" />
    <div class="row company-info-wrapper">
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
        <p class="company-info-title">关于我们</p>
        <p class="company-info-text">
          广州市同慧信息科技有限公司是一间一直专注于行政事业单位的软件信息系统服务的公司，包括自主开发财务系统和资产内控管理系统，包括自主开发财务系统和资产内控管理系统也为广州市本级，广东省本级，天河区和从化区本级的部分客户提供财政系统技术支持与业务咨询服务。公司统一社会信用代码为91440101MA59M68875，成立于2017年。
        </p>
        <p class="company-info-text">
          2019年在惠州市全市法院案款改革中，惠州市中院和下级法院都采用我公司案款财务系统记账，并为全市法院财务系统连通省法案执行款系统提供技术服务，实现对执行案款的无缝链接，同时惠州市也成为广东省法院系统执行款改革试点。目前在惠州，河源，清远，潮州饶平，茂名，广州等法院上线运行。
        </p>
        <span class="more" @click="handleMore">了解更多</span>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-8 col-lg-8 hidden-xs company-info-imgs">
        <img src="../../assets/home/info1.png" alt="" />
        <img src="../../assets/home/info2.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import HomeTitle from "./homeItemTitle.vue";
export default {
  components: {
    HomeTitle,
  },
  methods: {
    handleMore() {
      this.$router.push({
        path: "/companyProfile",
      });
    },
  },
};
</script>
<style scoped>
.company-info {
  padding-top: 32px;
}
.company-info-wrapper {
  padding: 15px 62px 32px 62px;
  height: 360px;
}
.company-info-text {
  font-size: 12px;
  font-weight: 400;
  color: #1e1e1e;
  line-height: 18px;
  text-indent: 18px;
  margin-bottom: 10px;
}
.company-info-title {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.company-info-imgs {
  position: relative;
}
.company-info-imgs > img:nth-child(1) {
  width: 70%;
  position: absolute;
  top: 20px;
  height: calc(100% - 40px);
  left: 0;
}
.company-info-imgs > img:nth-child(2) {
  width: 70%;
  position: absolute;
  height: 100%;
  top: 0px;
  right: 10px;
}
.more {
  margin-top: 20px;
  font-size: 10px;
  font-weight: bold;
  color: #2c2c2c;
  line-height: 14px;
  cursor: pointer;
  border-radius: 14px;
  padding: 4px 20px;
  border: 1px solid #e2e2e2;
}
.more:hover {
  background-color: #346bdc;
  border-color: #346bdc;
  color: #ffffff;
}
@media (min-width: 768px) {
  .company-info-wrapper {
    display: flex;
    justify-content: space-around;
  }
}
@media (max-width: 768px) {
  .company-info-wrapper {
    height: 460px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/companyInfo.vue